import './PBFNotificationDialog.style.less'
import { Button, Modal, Row } from 'antd'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import HttpRequest from '@/config/axios.config'
import { notification_types } from '@/constant/notification_type'
import { useAtom } from 'jotai'
import { notificationTaskIdAtom } from '@/jotai/notification.jotai'
import { isEmptyValue } from '@/utils/common'

interface Prop {
  open: boolean
  data: any
  isFetching: boolean
  hasNextPage: boolean
  fetchNextPage: () => void
  onCancel: () => void
}

enum NotificationModule {
  QSF = 1,
  PBF = 2,
  LIVEBOARD = 3,
}

function PBFNotificationDialog(props: Prop) {
  const { open, data, hasNextPage, fetchNextPage, onCancel } = props

  const navigate = useNavigate()

  const [, setTaskId] = useAtom(notificationTaskIdAtom)

  const navigateNotification = (item, replace?: boolean) => {
    if (isEmptyValue(item.type)) {
      navigate(
        `/pbf/orders/${encodeURIComponent(item?.title)}?orderKey=${
          item.reference_id
        }&activeTab=2&panelType=timeline`,
        {
          replace: replace ?? false,
        }
      )
      return
    }
    switch (item.type) {
      case notification_types.task_comment:
        setTaskId({
          taskId: item?.json_value.task_id,
          commentId: item?.json_value?.comment_id,
          documentId: null,
        })
        navigate(
          `/pbf/orders/${encodeURIComponent(item?.title)}?orderKey=${
            item?.json_value?.order_id
          }&activeTab=2&panelType=tasks&sectionId=${
            item?.json_value?.section_id
          }`,
          {
            replace: replace ?? false,
          }
        )
        break
      case notification_types.task_document:
        setTaskId({
          taskId: item?.json_value.task_id,
          commentId: null,
          documentId: item?.json_value?.media_id,
        })
        navigate(
          `/pbf/orders/${encodeURIComponent(item?.title)}?orderKey=${
            item?.json_value?.order_id
          }&activeTab=2&panelType=tasks&sectionId=${
            item?.json_value?.section_id
          }`,
          {
            replace: replace ?? false,
          }
        )
        break
      case notification_types.order_assign:
        navigate(
          `/pbf/orders/${encodeURIComponent(item?.title)}?orderKey=${
            item?.json_value?.order_id
          }&activeTab=2&panelType=timeline`,
          {
            replace: replace ?? false,
          }
        )
        break
      default:
        navigate(
          `/pbf/orders/${encodeURIComponent(item?.title)}?orderKey=${
            item?.json_value?.order_id
          }&activeTab=2&panelType=tasks&sectionId=${
            item?.json_value?.section_id
          }`,
          {
            replace: replace ?? false,
          }
        )
        break
    }
  }

  const onViewNotification = (item) => {
    HttpRequest.put(`notifications/${item.id}/read`)
      .then((res) => {
        if (res.data?.data?.id) {
          if (res.data.data.modules_id === NotificationModule.QSF) {
            navigate(
              `/qsf/inspection/${encodeURIComponent(
                item?.title
              )}?inspectionKey=${item?.reference_id}`
            )
          } else if (res.data.data.modules_id === NotificationModule.PBF) {
            if (window.location.pathname.includes('/pbf/orders/')) {
              navigate('/loading', { replace: true })
              setTimeout(() => {
                navigateNotification(item, true)
              }, 100)
            } else {
              navigateNotification(item)
            }
          }
          onCancel()
        }
      })
      .catch((error) => console.error(error))
  }

  return (
    <Modal
      title="Notifications"
      open={open}
      footer={null}
      width={800}
      onCancel={onCancel}
    >
      <div
        className="modal-dialog-content-container"
        style={{ height: 622, overflow: 'auto' }}
      >
        {data?.pages.map((group, i) => (
          <div key={i}>
            {group.data?.data?.list.map((item) => {
              return (
                <div
                  key={item.id}
                  className="list-item-container hoverable"
                  onClick={() => onViewNotification(item)}
                >
                  <div className="notification-content-container">
                    <div
                      style={{ opacity: item?.is_read ? 0 : 1 }}
                      className="is-read-dot"
                    />
                    <div className="content">
                      <h6>{item?.title}</h6>
                      <div
                        className="content-text"
                        id="userMention"
                        dangerouslySetInnerHTML={{
                          __html: item?.content,
                        }}
                      />
                    </div>
                    <div>
                      <span>{moment(item?.created_date).format('DD MMM')}</span>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        ))}
        {hasNextPage && (
          <Row justify={'center'}>
            <Button
              onClick={() => fetchNextPage()}
              style={{ borderRadius: 10 }}
              type="primary"
            >
              Load More
            </Button>
          </Row>
        )}
      </div>
    </Modal>
  )
}

export default PBFNotificationDialog
